<div class="callout-container">
	<h3 class="header">{{headerText}}</h3>
	<p class="body">{{bodyText}}</p>
</div>
